import cn from 'classnames';
import { I18nt } from 'utils';
import { LangText } from 'utils/interfaces';
import styles from './Info.module.less';

interface Props {
	title?: LangText;
	body?: LangText;
	icon?: JSX.Element;
	show?: boolean;
	className?: string;
}

export default function Info({
	title,
	body,
	icon,
	className,
	show = false,
}: Props) {
	if (!show) {
		return null;
	}

	return (
		<div className={cn(styles.info, className)}>
			{icon && <div className='mr-8'>{icon}</div>}
			<div>
				{title && <div className={styles.infoTitle}>{I18nt(title)}</div>}
				{body && <span>{I18nt(body)}</span>}
			</div>
		</div>
	);
}
